/* ==========================================================================
   Kuji Collection Board
   Ersetzt Filter-/Sortier-Leiste und Layout-Umschalter des Themes durch
   eine schlanke Leiste: Umschalter "Aktive / Alle" + Serien-Dropdown.
   Karten werden NICHT aus dem Grid entfernt, nur per Klasse markiert und
   über CSS `order` einsortiert — sonst brechen Load-More und Section-Render.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  var URGENT_RATIO = 1 / 3;
  var MAX_LOAD_ROUNDS = 12;

  var tools = null;
  var grid = null;
  var collection = null;
  var board = null;
  var archiveHead = null;
  var emptyBox = null;
  var labels = {};

  var state = {
    view: 'live',
    serie: '',
    loadingAll: false,
    allLoaded: false
  };

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function items() {
    return grid ? $$(':scope > .grid-item', grid) : [];
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------------------------------------------------------------- Helpers */

  function isEnded(item) {
    return !!(
      item.querySelector('.kuji-end-badge') ||
      item.querySelector('.badge.sold-out') ||
      item.querySelector('.price--sold-out')
    );
  }

  function serieOf(item) {
    var link = item.querySelector('.card-heading a');
    if (!link) return '';
    var parts = link.textContent.trim().split(/\s+[–—-]\s+/);
    if (parts.length < 2) return '';
    return parts[0].trim();
  }

  function ticketRatio(item) {
    var left = item.querySelector('.kuji-live-count');
    var total = item.querySelector('.kuji-live-total');
    if (left && total) {
      var l = parseInt(left.textContent.replace(/\D/g, ''), 10);
      var t = parseInt(total.textContent.replace(/\D/g, ''), 10);
      if (!isNaN(l) && !isNaN(t) && t > 0) {
        return { left: l, total: t, ratio: l / t };
      }
    }
    var fill = item.querySelector('.kuji-progress-fill');
    if (fill && fill.style.width) {
      var pct = parseFloat(fill.style.width);
      if (!isNaN(pct)) return { left: null, total: null, ratio: pct / 100 };
    }
    return null;
  }

  /* ------------------------------------------------------- Karten aufwerten */

  function decorate(item) {
    var ended = isEnded(item);
    item.classList.toggle('kjc-item--ended', ended);
    item.classList.toggle('kjc-item--live', !ended);

    var serie = serieOf(item);
    if (serie) item.dataset.kjcSerie = serie;

    if (serie && !item.querySelector('.kjc-serie-label')) {
      var heading = item.querySelector('.card-heading');
      if (heading && heading.parentNode) {
        var label = document.createElement('span');
        label.className = 'kjc-serie-label';
        label.textContent = serie;
        heading.parentNode.insertBefore(label, heading);
      }
    }

    if (ended) {
      decorateEnded(item);
    } else {
      decorateLive(item);
    }
  }

  function decorateEnded(item) {
    if (item.querySelector('.kjc-ended-chip')) return;
    var area = item.querySelector('.kuji-bottom-area') || item.querySelector('.kuji-card-info-block');
    if (!area) return;
    var chip = document.createElement('span');
    chip.className = 'kjc-ended-chip';
    chip.textContent = labels.ended || 'Beendet';
    area.insertBefore(chip, area.firstChild);
  }

  function decorateLive(item) {
    if (!item.querySelector('.kjc-cta')) {
      var link = item.querySelector('.card-heading a');
      var area = item.querySelector('.kuji-bottom-area');
      if (link && area) {
        var cta = document.createElement('a');
        cta.className = 'kjc-cta';
        cta.href = link.getAttribute('href');
        cta.textContent = labels.cta || 'Jetzt ziehen';
        cta.setAttribute('aria-label', (labels.cta || 'Jetzt ziehen') + ': ' + link.textContent.trim());
        area.appendChild(cta);
      }
    }
    updateUrgency(item);
  }

  function updateUrgency(item) {
    var data = ticketRatio(item);
    if (!data) return;
    item.dataset.kjcRatio = String(data.ratio);

    var urgent = data.ratio > 0 && data.ratio <= URGENT_RATIO;
    var flag = item.querySelector('.kjc-flag');

    if (urgent && !flag) {
      var media = item.querySelector('.card-inner') || item.querySelector('.card-media');
      if (media) {
        flag = document.createElement('span');
        flag.className = 'kjc-flag';
        flag.textContent = urgencyText(data.left);
        media.appendChild(flag);
      }
    } else if (!urgent && flag) {
      flag.remove();
    } else if (urgent && flag && data.left !== null) {
      flag.textContent = urgencyText(data.left);
    }
  }

  /* Alle sichtbaren Texte kommen aus den Section-Einstellungen, damit sie
     im Theme-Editor änderbar und übersetzbar bleiben. */
  function urgencyText(left) {
    if (left === null) return labels.urgency || 'Bald ausverkauft';
    var template = labels.urgencyLeft || 'Nur noch {count}';
    return template.replace('{count}', left);
  }

  /* ------------------------------------------------- Trennzeile + Leermeldung */

  /* Beendet heißt nicht vorbei: beliebte Sets werden neu aufgelegt. Deshalb
     erklärt die Trennzeile das Archiv, statt es nur zu betiteln. */
  function ensureArchiveHead() {
    if (archiveHead && archiveHead.parentNode === grid) return archiveHead;
    archiveHead = document.createElement('div');
    archiveHead.className = 'kjc-archive-head';

    var html =
      '<div class="kjc-archive-head__row">' +
      '<span class="kjc-archive-head__title">' +
      escapeHtml(labels.archive || 'Beendete Kuji') +
      '</span>' +
      '<span class="kjc-archive-head__count" data-kjc-archive-count></span>' +
      '</div>';

    if (labels.archiveNote) {
      html += '<p class="kjc-archive-head__note">' + escapeHtml(labels.archiveNote) + '</p>';
    }
    if (labels.kujidexUrl && labels.kujidexLabel) {
      html +=
        '<a class="kjc-archive-head__link" href="' +
        escapeHtml(labels.kujidexUrl) +
        '">' +
        escapeHtml(labels.kujidexLabel) +
        '</a>';
    }

    archiveHead.innerHTML = html;
    grid.appendChild(archiveHead);
    return archiveHead;
  }

  function ensureEmptyBox() {
    if (emptyBox && emptyBox.parentNode === grid) return emptyBox;
    emptyBox = document.createElement('div');
    emptyBox.className = 'kjc-empty';

    var html =
      '<p class="kjc-empty__text"></p>' +
      '<button type="button" class="kjc-empty__btn" data-kjc-reset></button>';

    if (labels.emptyNote) {
      html += '<p class="kjc-empty__note">' + escapeHtml(labels.emptyNote) + '</p>';
    }
    if (labels.communityUrl) {
      html +=
        '<a class="kjc-empty__link" href="' +
        escapeHtml(labels.communityUrl) +
        '" target="_blank" rel="noopener">' +
        escapeHtml(labels.communityLabel || 'In der Community fragen') +
        '</a>';
    }

    emptyBox.innerHTML = html;
    grid.appendChild(emptyBox);
    return emptyBox;
  }

  /* -------------------------------------------------------------- Filtern */

  function applyFilters() {
    var visibleLive = 0;
    var visibleEnded = 0;

    items().forEach(function (item) {
      var ended = item.classList.contains('kjc-item--ended');
      var hide = false;

      if (state.serie && item.dataset.kjcSerie !== state.serie) hide = true;
      if (state.view === 'live' && ended) hide = true;

      item.classList.toggle('kjc-hidden', hide);
      if (hide) return;
      if (ended) {
        visibleEnded++;
      } else {
        visibleLive++;
      }
    });

    var head = ensureArchiveHead();
    var showHead = state.view === 'all' && visibleEnded > 0;
    head.hidden = !showHead;
    if (showHead) {
      var count = $('[data-kjc-archive-count]', head);
      if (count) count.textContent = String(visibleEnded);
    }

    var box = ensureEmptyBox();
    var empty = visibleLive + visibleEnded === 0;
    box.hidden = !empty;
    if (empty) {
      var text = $('.kjc-empty__text', box);
      var btn = $('.kjc-empty__btn', box);
      if (state.view === 'live' && state.serie) {
        text.textContent = labels.empty || 'Für diese Serie läuft gerade kein Kuji.';
        btn.textContent = labels.archiveCta || 'Beendete Kuji ansehen';
        btn.dataset.kjcResetTo = 'all';
      } else {
        text.textContent = labels.emptyAll || 'Keine Kuji gefunden.';
        btn.textContent = labels.allSeries || 'Alle Serien';
        btn.dataset.kjcResetTo = 'serie';
      }
    }

    ROOT.classList.toggle('kjc-view-live', state.view === 'live');
  }

  /* --------------------------------------------------------- Serien-Auswahl */

  function serieCounts() {
    var counts = {};
    var order = [];
    var total = 0;

    items().forEach(function (item) {
      if (state.view === 'live' && item.classList.contains('kjc-item--ended')) return;
      total++;
      var serie = item.dataset.kjcSerie;
      if (!serie) return;
      if (!counts[serie]) {
        counts[serie] = 0;
        order.push(serie);
      }
      counts[serie]++;
    });

    order.sort(function (a, b) {
      return counts[b] - counts[a] || a.localeCompare(b);
    });

    // Gewählte Serie bleibt wählbar, auch wenn sie in dieser Ansicht leer ist
    if (state.serie && order.indexOf(state.serie) === -1) order.unshift(state.serie);

    return { list: order, counts: counts, total: total };
  }

  function buildSerieOptions() {
    if (!board) return;
    var panel = $('[data-kjc-select-panel]', board);
    if (!panel) return;

    var data = serieCounts();
    var signature =
      state.view +
      '#' +
      state.serie +
      '#' +
      data.total +
      '#' +
      data.list
        .map(function (serie) {
          return serie + ':' + (data.counts[serie] || 0);
        })
        .join('|');
    if (panel.dataset.signature !== signature) {
      panel.dataset.signature = signature;

      /* Nachladen kann die Liste unter einem gerade fokussierten Eintrag
         austauschen. Deshalb merken wir uns die Auswahl und setzen den
         Fokus danach auf denselben Eintrag zurück. */
      var focusedValue = null;
      if (panel.contains(document.activeElement)) {
        var current = document.activeElement.closest('[data-kjc-serie]');
        if (current) focusedValue = current.dataset.kjcSerie;
      }

      optionSeq = 0;
      var html = optionHtml('', labels.allSeries || 'Alle Serien', data.total);
      data.list.forEach(function (serie) {
        html += optionHtml(serie, serie, data.counts[serie] || 0);
      });
      panel.innerHTML = html;

      if (focusedValue !== null) {
        var again = panel.querySelector('[data-kjc-serie="' + cssEscape(focusedValue) + '"]');
        (again || panel.querySelector('.kjc-opt') || panel).focus();
      }
    }

    var labelOut = $('[data-kjc-select-label]', board);
    if (labelOut) labelOut.textContent = state.serie || labels.allSeries || 'Alle Serien';

    var select = $('[data-kjc-select]', board);
    if (select) select.classList.toggle('is-filtered', !!state.serie);
  }

  var optionSeq = 0;

  function optionHtml(value, text, count) {
    var active = state.serie === value;
    optionSeq++;
    return (
      '<button type="button" id="kjc-opt-' +
      optionSeq +
      '" class="kjc-opt' +
      (active ? ' is-active' : '') +
      '" role="option" tabindex="-1" aria-selected="' +
      (active ? 'true' : 'false') +
      '" data-kjc-serie="' +
      escapeHtml(value) +
      '">' +
      '<span class="kjc-opt__text">' +
      escapeHtml(text) +
      '</span>' +
      '<span class="kjc-opt__n">' +
      count +
      '</span>' +
      '</button>'
    );
  }

  /* CSS.escape gibt es nicht überall; für Attributwerte reichen
     Anführungszeichen und Backslashes. */
  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function isSelectOpen() {
    var select = board && $('[data-kjc-select]', board);
    return !!(select && select.classList.contains('is-open'));
  }

  function selectOptions() {
    var panel = board && $('[data-kjc-select-panel]', board);
    return panel ? $$('.kjc-opt', panel) : [];
  }

  function setSelectOpen(open, options) {
    var select = board && $('[data-kjc-select]', board);
    if (!select) return;

    var wasOpen = select.classList.contains('is-open');
    select.classList.toggle('is-open', !!open);

    var btn = $('[data-kjc-select-toggle]', select);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');

    var panel = $('[data-kjc-select-panel]', select);
    if (panel) panel.hidden = !open;

    if (open) {
      /* Erst beim Öffnen der Serien-Auswahl lohnt sich der komplette
         Bestand — vorher filtert niemand. */
      loadAll();
    } else if (wasOpen && options && options.returnFocus && btn) {
      btn.focus();
    }
  }

  function focusOption(index) {
    var opts = selectOptions();
    if (!opts.length) return;
    var i = Math.max(0, Math.min(index, opts.length - 1));
    opts[i].focus();
  }

  function focusActiveOption() {
    var opts = selectOptions();
    if (!opts.length) return;
    var active = opts.filter(function (opt) {
      return opt.classList.contains('is-active');
    })[0];
    (active || opts[0]).focus();
  }

  /* Pfeiltasten, Pos1/Ende und Escape im geöffneten Dropdown. Auswahl
     selbst übernimmt der Button (Enter/Leertaste) über den Klick-Handler. */
  function onSelectKeydown(event) {
    if (!isSelectOpen()) return;

    var opts = selectOptions();
    var index = opts.indexOf(document.activeElement);

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        focusOption(index < 0 ? 0 : index + 1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        focusOption(index < 0 ? opts.length - 1 : index - 1);
        break;
      case 'Home':
        event.preventDefault();
        focusOption(0);
        break;
      case 'End':
        event.preventDefault();
        focusOption(opts.length - 1);
        break;
      case 'Escape':
        event.preventDefault();
        setSelectOpen(false, { returnFocus: true });
        break;
      case 'Tab':
        /* Tab verlässt das Dropdown. Der Fokus muss vor dem Ausblenden auf
           den Auslöser zurück, sonst steht er auf einem versteckten Element
           und der Browser springt an den Seitenanfang. Ohne preventDefault
           wandert er von dort regulär weiter. */
        setSelectOpen(false, { returnFocus: true });
        break;
      default:
        break;
    }
  }

  /* -------------------------------------------------------------- Reihenfolge */

  function applyOrder() {
    var index = 1;
    items().forEach(function (item) {
      if (item.classList.contains('kjc-item--live')) item.style.order = String(index++);
    });

    if (emptyBox) emptyBox.style.order = '400';
    if (archiveHead) archiveHead.style.order = '500';

    var endedIndex = 501;
    items().forEach(function (item) {
      if (item.classList.contains('kjc-item--ended')) {
        item.style.order = String(endedIndex++);
      }
    });
  }

  /* ---------------------------------------------------------------- Zähler */

  function updateCounts() {
    if (!board) return;
    var domLive = grid.querySelectorAll('.kjc-item--live').length;
    var serverLive = parseInt(tools.dataset.liveCount, 10);
    var live = Math.max(domLive, isNaN(serverLive) ? 0 : serverLive);

    var liveOut = $('[data-kjc-count-live]', board);
    if (liveOut) liveOut.textContent = String(live);

    var total = parseInt(tools.dataset.totalCount, 10);
    var allOut = $('[data-kjc-count-all]', board);
    if (allOut && !isNaN(total)) allOut.textContent = String(total);
  }

  /* ------------------------------------------------------------- Leiste */

  function mountBoard() {
    if (document.querySelector('.kjc-sticky')) return;
    board = $('[data-kjc-board]', tools);
    if (!board || !collection) return;

    var target = $('.product-grid-container', collection);
    if (!target) return;

    var wrap = document.createElement('div');
    wrap.className = 'kjc-sticky';
    if (tools.dataset.sticky === 'true') wrap.classList.add('is-sticky');

    var inner = document.createElement('div');
    inner.className = 'kjc-sticky__inner page-width';
    wrap.appendChild(inner);

    collection.insertBefore(wrap, target);
    inner.appendChild(board);
    board.hidden = false;

    $$('[data-kjc-view]', board).forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.dataset.kjcView);
      });
    });
  }

  function setView(view) {
    state.view = view === 'all' ? 'all' : 'live';
    $$('[data-kjc-view]', board).forEach(function (btn) {
      var on = btn.dataset.kjcView === state.view;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (state.view === 'all') loadAll();
    buildSerieOptions();
    applyFilters();
    applyOrder();
  }

  function setSerie(serie) {
    state.serie = serie || '';
    if (state.serie) loadAll();
    buildSerieOptions();
    applyFilters();
    applyOrder();
  }

  /* ---------------------------------------------- Alle Seiten nachladen */

  /* Beendete Kuji lösen keine Lottery-API-Calls aus, deshalb ist das
     Nachladen der Restseiten günstig — und nur so greift die Serien-Auswahl
     über den kompletten Bestand statt nur über die erste Seite. */
  function loadMoreButton() {
    var btn = document.getElementById('load-more');
    return btn && !btn.disabled ? btn : null;
  }

  /* Nach `load` und dann im ersten Leerlauf. requestIdleCallback fehlt in
     Safari älterer Versionen, dort bleibt ein kurzes Timeout. */
  function onIdle(fn) {
    function schedule() {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(fn, { timeout: 3000 });
      } else {
        setTimeout(fn, 1200);
      }
    }
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
  }

  /* Der "Mehr laden"-Button gehört dem Theme. Nach jeder Runde setzt es den
     Fokus auf die frisch eingehängten Karten, und weil im Theme
     `html { scroll-behavior: smooth }` steht, gleitet die Seite dabei sichtbar
     nach unten — nach der letzten Runde steht man beim letzten Kuji.

     Das Nachladen läuft im Hintergrund, niemand hat darum gebeten. Für die
     Dauer der Runden wird die Scrollposition deshalb festgehalten. Wischt
     oder scrollt der Besucher selbst, geben wir sie sofort frei und mischen
     uns nicht mehr ein. */
  function scrollPin() {
    var x = window.pageXOffset;
    var y = window.pageYOffset;
    var startActive = document.activeElement;
    var live = true;

    function release() {
      if (!live) return;
      live = false;
      window.removeEventListener('wheel', release);
      window.removeEventListener('touchmove', release);
    }

    function hold() {
      if (!live) return;

      // Fokus, den das Theme selbst ins Grid gesetzt hat, wieder abgeben
      var el = document.activeElement;
      if (el && el !== startActive && el.blur && grid && grid.contains(el)) el.blur();

      if (Math.abs(window.pageYOffset - y) < 2) return;
      /* Muss ohne Animation zurück, sonst kämpft der Sprung des Themes
         gegen die Korrektur. */
      try {
        window.scrollTo({ top: y, left: x, behavior: 'instant' });
      } catch (err) {
        window.scrollTo(x, y);
      }
    }

    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('touchmove', release, { passive: true });

    return { hold: hold, release: release };
  }

  function loadAll() {
    if (state.loadingAll || state.allLoaded) return;
    if (!loadMoreButton()) {
      state.allLoaded = true;
      return;
    }

    state.loadingAll = true;
    ROOT.classList.add('kjc-loading-all');

    var pin = scrollPin();
    var rounds = 0;

    function done() {
      state.loadingAll = false;
      state.allLoaded = true;
      ROOT.classList.remove('kjc-loading-all');
      process();

      /* Der Fokus-Sprung der letzten Runde kann noch nachkommen, deshalb
         hält der Pin kurz über das Ende hinaus. */
      pin.hold();
      setTimeout(function () {
        pin.hold();
        pin.release();
      }, 300);
    }

    function step() {
      var btn = loadMoreButton();
      if (!btn || rounds >= MAX_LOAD_ROUNDS) return done();
      rounds++;

      var before = items().length;
      btn.click();
      pin.hold();
      if (window.requestAnimationFrame) window.requestAnimationFrame(pin.hold);

      var waited = 0;
      var poll = setInterval(function () {
        waited += 200;
        pin.hold();
        if (items().length > before || !loadMoreButton() || waited >= 8000) {
          clearInterval(poll);
          if (waited >= 8000 && items().length === before) return done();
          setTimeout(function () {
            pin.hold();
            step();
          }, 150);
        }
      }, 200);
    }

    setTimeout(step, 0);
  }

  /* ----------------------------------------------------------- Überlappung */

  /* Sicherheitsnetz: falls im Theme-Editor wieder "Abstände ignorieren"
     gesetzt wird, zieht die Grid-Section sich negativ nach oben. */
  function fixOverlap() {
    if (!collection || !collection.closest) return;
    var section = collection.closest('.shopify-section');
    if (!section) return;

    var prev = section.previousElementSibling;
    while (prev && prev.getBoundingClientRect().height === 0) {
      prev = prev.previousElementSibling;
    }
    if (!prev) return;

    /* Zum Messen muss ein bereits gesetztes Padding raus — aber nur, wenn
       überhaupt eines gesetzt ist. */
    if (collection.style.paddingTop) collection.style.paddingTop = '0px';

    var overlap = prev.getBoundingClientRect().bottom - collection.getBoundingClientRect().top;
    var next = overlap > 0 ? Math.ceil(overlap + 10) + 'px' : '';

    /* Nur schreiben, wenn sich wirklich etwas ändert. Sonst landet bei
       jedem Aufruf eine Style-Änderung im Baum und die Seite rechnet ihr
       Layout neu, obwohl das Ergebnis dasselbe ist. */
    if (collection.style.paddingTop !== next) collection.style.paddingTop = next;
  }

  /* -------------------------------------------------------------- Durchlauf */

  var processing = false;

  function process() {
    if (processing || !grid) return;
    processing = true;

    items().forEach(decorate);

    buildSerieOptions();
    applyFilters();
    applyOrder();
    updateCounts();

    processing = false;
  }

  function refreshUrgency() {
    items().forEach(function (item) {
      if (item.classList.contains('kjc-item--live')) updateUrgency(item);
    });
  }

  /* ------------------------------------------------------------------- Init */

  var booted = false;

  function init() {
    tools = $('[data-kjc-tools]');
    var nextGrid = document.getElementById('product-grid');
    collection = $('.collection');
    if (!tools || !nextGrid) return;
    if (nextGrid !== grid) {
      archiveHead = null;
      emptyBox = null;
    }
    grid = nextGrid;

    labels = {
      active: tools.dataset.activeLabel,
      all: tools.dataset.allLabel,
      archive: tools.dataset.archiveLabel,
      cta: tools.dataset.ctaLabel,
      urgency: tools.dataset.urgencyLabel,
      ended: tools.dataset.endedLabel,
      allSeries: tools.dataset.allSeriesLabel,
      empty: tools.dataset.emptyText,
      emptyAll: tools.dataset.emptyAllText,
      emptyNote: tools.dataset.emptyNote,
      archiveNote: tools.dataset.archiveNote,
      archiveCta: tools.dataset.archiveCtaLabel,
      urgencyLeft: tools.dataset.urgencyLeftLabel,
      kujidexLabel: tools.dataset.kujidexLabel,
      kujidexUrl: tools.dataset.kujidexUrl,
      communityUrl: tools.dataset.communityUrl,
      communityLabel: tools.dataset.communityLabel
    };

    ROOT.classList.add('kjc-on');

    mountBoard();
    process();
    fixOverlap();

    if (booted) return;
    booted = true;

    /* Die Restseiten werden gebraucht: der "Aktive"-Zähler und die
       Serien-Auswahl zählen über den DOM, nicht über den Server — mit nur
       einer Seite im Grid wären beide zu niedrig.

       Sie dürfen nur nicht mit dem ersten Rendern konkurrieren. Früher lief
       das über setTimeout(1500), also mitten in die Ladephase hinein. Jetzt
       startet es nach `load` und erst wenn der Browser Leerlauf meldet.
       Greift jemand vorher zur Filterleiste, holt setSelectOpen()/setView()
       den Bestand sofort — der Zähler ist dann trotzdem korrekt. */
    onIdle(loadAll);

    // Ticketstände kommen asynchron aus der Lottery-API nach
    [700, 1800, 3500].forEach(function (delay) {
      setTimeout(function () {
        refreshUrgency();
        fixOverlap();
      }, delay);
    });

    /* Auf dem Handy feuert `resize` auch beim Scrollen, weil die Adressleiste
       ein- und ausfährt. Die Breite bleibt dabei gleich, nur die Höhe ändert
       sich. Vorher lief deshalb bei jedem Scrollen fixOverlap() und schrieb
       ein neues Padding — die Seite ruckelte immer wieder nach, als würde sie
       sich dauernd neu aufbauen. Jetzt zählt nur noch eine echte
       Breitenänderung. */
    var resizeTimer = null;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fixOverlap, 250);
    });

    // Drehen ändert die Breite, meldet sie aber teils erst nach dem Event
    window.addEventListener('orientationchange', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        lastWidth = window.innerWidth;
        fixOverlap();
      }, 250);
    });

    window.addEventListener('load', fixOverlap);

    var gridObserver = new MutationObserver(function (mutations) {
      var added = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length;
      });
      if (added) process();
    });
    gridObserver.observe(grid, { childList: true });

    // Section-Render tauscht das komplette Grid aus
    if (collection) {
      new MutationObserver(function () {
        if (processing) return;
        var current = document.getElementById('product-grid');
        if (!current || current === grid) return;
        grid = current;
        archiveHead = null;
        emptyBox = null;
        gridObserver.disconnect();
        gridObserver.observe(grid, { childList: true });
        process();
      }).observe(collection, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-kjc-select-toggle]')) {
        setSelectOpen(!isSelectOpen());
        return;
      }

      /* Nur Einträge aus dem Auswahlfeld dürfen filtern. `data-kjc-serie`
         steht auch auf jeder Karte — decorate() schreibt es dort für die
         Filterung selbst hin. Ohne die Eingrenzung auf das Panel traf
         `closest` beim Klick auf ein Kuji die Karte, und der Filter sprang
         auf deren Serie, während die Produktseite lud. */
      var option = target.closest('[data-kjc-select-panel] [data-kjc-serie]');
      if (option) {
        // Enter/Leertaste melden detail 0, ein echter Klick 1
        var fromKeyboard = !event.detail;
        setSerie(option.dataset.kjcSerie);
        setSelectOpen(false, { returnFocus: !!fromKeyboard });
        return;
      }

      var reset = target.closest('[data-kjc-reset]');
      if (reset) {
        if (reset.dataset.kjcResetTo === 'all') {
          setView('all');
        } else {
          setSerie('');
        }
        return;
      }

      if (!target.closest('[data-kjc-select]')) setSelectOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      var target = event.target;

      // Vom Auslöser aus mit Pfeil runter / hoch direkt in die Liste springen
      if (target && target.closest && target.closest('[data-kjc-select-toggle]')) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!isSelectOpen()) setSelectOpen(true);
          focusActiveOption();
          return;
        }
      }

      onSelectKeydown(event);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    if (!document.getElementById('product-grid')) return;
    init();
  });
})();
